import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store/configureStore";
import CountersService from "Services/counters";
import { ICounters } from "../types/counters";

interface ICountersState {
  loading: boolean;
  data: ICounters[];
  errors: any;
}

const initialState: ICountersState = {
  loading: false,
  data: [],
  errors: {},
};

const countersSlice = createSlice({
  name: "counters",
  initialState,
  reducers: {
    setLoader: (state) => {
      state.loading = true;
      state.errors = initialState.errors;
    },
    setData: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.data = payload;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.errors = payload;
    },
  },
});

const { setLoader, setData, setError } = countersSlice.actions;

export const getCountersActiveUsersZones = (): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await CountersService.getActiveUsersZones();
    dispatch(setData(response));
  } catch (error) {
    dispatch(setError(error));
  }
};

export default countersSlice.reducer;
